<template>
	<div style="position: relative; padding: 0; margin: 0">
		<vue-particles color="#fff" :particleOpacity="0.7" :particlesNumber="30" shapeType="circle" :particleSize="10"
			linesColor="#fff" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="2"
			:hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push" class="lizi">
		</vue-particles>

		<div class="rightMenu">
			<div class="titleBox">
				<div class="title">
					EXPRESS
				</div>
			</div>
			<div class="imgBox">
				<img src="../../assets/erweima.jpg" class="img">
			</div>
			<div class="" style="text-align: center;margin-top: 2vw;margin-right: 2vw;">
				<div class="" style="font-weight: bolder;font-size: 1.5vw;">
					Hello,欢迎来到省拼达
				</div>
				<div style="margin-top: 2vw;">
					WELCOME TO SHENGPINDA
				</div>
				<div
					style="padding: 0.8em;margin: 2vw 3vw 0;background-color: #ffc15c;border-radius: 1em;font-size: 1.2em;box-shadow: 0 0 1em rgba(255, 193, 92,0.5);">
					微信扫一扫立即使用
				</div>
			</div>
		</div>
		<div class="wave">
			<img src="@/assets/title.png" class="titleImg" />
			<img src="@/assets/subTitle.svg" class="subTitleImg" />
			<img src="@/assets/decorate.svg" class="decorate" style="" />
			<img src="@/assets/decorate.svg" class="decorate2" style="" />
			<img src="@/assets/dialogue.png" class="dialogue" />
			<img src="@/assets/dialogue2.png" class="dialogue2" />
			<img src="@/assets/wave.svg" class="topWave" />
			<img src="@/assets/wave2.svg" class="_topWave" />
			<img src="@/assets/truck.jpg" class="truck" />
		</div>
		<div
			style="position: fixed;bottom: 0px;left:0;right:0;text-align:center;background: rgba(0, 0, 0, 0.5);padding: 8px;color: white;">
			<!-- <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44190002005619"
				class="beian">
				<img src="@/static/image/beian.png" alt="备案图标" />
				<div>粤公网安备xxxxxxx号</div>
			</a> -->
			<a href="http://beian.miit.gov.cn" target="_blank" style="color: white;">粤ICP备2023143355号</a>
			<span> | 省拼达 版权所有 ©2025</span>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	created() {},
	methods: {}
};
</script>

<style scoped>
.lizi {
	position: absolute;
	right: 0;
	width: 50vw;
	height: 100vh;
}

.rightMenu {
	position: absolute;
	right: 0;
	top: 0;
	display: flex;
	flex-wrap: wrap;
	width: 25vw;
	justify-content: center;
}

.titleBox {
	width: 20vw;
	padding-right: 2vw;
	margin: 2vw 0;
}

.title {
	text-align: center;
	width: 5em;
	font-size: 25px;
	border-radius: 25px;
	background-color: #3e83ea;
	padding: 10px 15px;
	color: #fff;
	margin: 25px 0px 0px auto;
}

.imgBox {
	/* margin-right: 2vw; */
	margin: 2vw 2vw 2vw 0;
	width: 20vw;
	height: 20vw;
	border-radius: 50%;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
	overflow: hidden;
}

.imgBox img {
	width: 100%;
	height: 100%;
}

.wave {
	padding: 0;
	margin: 0;
	width: 100%;
	height: 100vh;
	right: 0;
	top: 0;
	overflow: hidden;
	position: absolute;
	user-select: none;
	z-index: -9;
}

.topWave {
	width: 75%;
	height: 100%;
	object-fit: cover;
	position: absolute;
	right: -15%;
	top: 0;
	object-position: 50% 40%;
	z-index: -1;
}

._topWave {
	width: 64%;
	height: 100%;
	object-fit: cover;
	position: absolute;
	right: -10%;
	top: 0;
	object-position: 50% 70%;
	z-index: -2;
}

.truck {
	width: 65vw;
	object-fit: cover;
	/* height: 35rem; */
	/* width: 65%;
	height: 55%; */
	position: absolute;
	bottom: 0;
	left: -15%;
	z-index: -4;
	user-select: none;
}

.titleImg {
	position: absolute;
	top: 15vh;
	left: 5vw;
	object-fit: cover;
	width: 65rem;
	/* height: 10rem; */
}

.subTitleImg {
	position: absolute;
	top: 26vh;
	left: 5vw;
	object-fit: cover;
	width: 60rem;
}

.dialogue {
	position: absolute;
	top: 42vh;
	left: 50vw;
	object-fit: cover;
	width: 8rem;
}

.dialogue2 {
	position: absolute;
	top: 55vh;
	left: 1vw;
	object-fit: cover;
	width: 10rem;
	user-select: none;
}

.decorate {
	position: absolute;
	top: 45vh;
	left: 56vw;
	object-fit: cover;
	width: 10rem;
}

.decorate2 {
	position: absolute;
	top: 50vh;
	left: 10vw;
	object-fit: cover;
	width: 10rem;
}
</style>
